
  import { mapState, mapActions, mapMutations } from 'vuex'

  import FormField from '../../../_globals/forms/FormField.vue'
  import Icon from '../../../common/Icon'

  export default {
    name: 'Coupon',
    components: {
      FormField,
      Icon,
    },
    props: {
      data: {
        type: Object,
        default: () => {}
      },
      config: Object,
    },
    data() {
      return {
        animation: false,
      }
    },
    computed: {
      ...mapState({
        cart: state => state.cart,
      }),
      codeApplied() {
        if (this.cart && this.cart.coupon) {
          return this.cart.coupon.code
        }

        return false
      },
      couponField() {
        if (this.config?.couponField) {
          const { couponField } = this.config
          couponField.value = this.codeApplied ? this.codeApplied : ''

          return couponField
        }

        return {
          name: 'coupon',
          label: 'Type Coupon Code',
          type: 'text',
          placeholder: 'Enter Coupon Code',
          min: 1,
          max: 32,
          value: this.codeApplied ? this.codeApplied : '',
          touched: false,
          error: null,
          errors: {
            invalid: 'Please enter a valid coupon code.'
          }
        }
      },
    },
    methods: {
      ...mapActions([ 'getCart' ]),
      ...mapActions({
        validateCart: 'checkout/validateCart',
        applyCartCoupon: 'checkout/applyCartCoupon',
        removeCartCoupon: 'checkout/removeCartCoupon',
      }),
      ...mapMutations([ 'setLoading', 'setErrors']),
      async applyCoupon() {
        if (this.couponField.value && this.couponField.error === null) {
          await this.applyCartCoupon(this.couponField.value)
          this.setLoading(true)
          let invalidCart = await this.validateCart()
          if (invalidCart) {
            this.setErrors([ invalidCart ])
          } else {
            await this.getCart()
            if (this.codeApplied) {
              this.animation = true
              
              // fades the Applied state
              setTimeout(() => {
                this.animation = false
              }, 3000)
            }
          }
          this.setLoading(false)
        }
      },
      async removeCoupon() {
        await this.removeCartCoupon()
        this.setLoading(true)
        let invalidCart = await this.validateCart()
        if (invalidCart) {
          this.setErrors([ invalidCart ])
        } else {
          await this.getCart()
        }
        this.setLoading(false)
      },
    }
  }
